import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { endOfDay, getUnixTime, startOfDay, subDays } from 'date-fns';

import { apiClient } from '@services/apiClient';

interface IOptions {
  pointId: number;
  readingTypeId: number;
  time: number;
  pointType: string;
}

interface IParams {
  installationPointId: string | number;
  readingTypeId: string | number;
  range?: string | number;
  from?: string | number;
  to?: string | number;
}

interface IResponse {
  data: Array<[number, number]>;
  installationPointId: number;
  readingTypeId: number;
}

export const chartKey = (options: IOptions) => [
  'chart',
  +options?.pointId,
  +options?.readingTypeId,
  getUnixTime(startOfDay(subDays(new Date(), options?.time))),
  getUnixTime(endOfDay(new Date())),
  options.pointType,
  options?.time * 24 * 3600 * 1000,
];

export const chartFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) => {
  const params: IParams = {
    installationPointId: queryKey[1],
    readingTypeId: queryKey[2],
  };

  if (queryKey[5] === 'adapter') {
    params['range'] = queryKey[6];
  } else {
    params['from'] = queryKey[3];
    params['to'] = queryKey[4];
  }

  return apiClient.get(`${APP_API_URL_V2}fsd/charts`, {
    params,
  });
};

const chartSelect = ({ data }: AxiosResponse<IResponse>) => {
  return data?.data;
};

export const useChartQuery = (options: IOptions) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: chartKey(options),
    queryFn: chartFn,
    enabled: !!options?.readingTypeId,
    select: chartSelect,
    placeholderData: {
      data: {
        data: [],
        installationPointId: null,
        readingTypeId: null,
      },
    },
  });
};
